<template>
  <v-container>
    <v-layout text-center wrap>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          Captura Servicio Por Voz
        </h1>

      </v-flex>
      <v-flex xs12>
        <v-img :src="require('../assets/logo.jpg')" class="my-3" contain height="300"></v-img>
      </v-flex>

      <v-container fill-height fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center">
            <v-btn color="primary" @click="iniciarReconocimiento">
              🎤 Hablar
            </v-btn>
            <p v-if="transcript" class="mt-4">
              Texto reconocido: <strong>{{ textoSinEspacios }}</strong>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
  </v-container>
</template>


<script>

import axios from "axios";
import moment from "moment";
import { Promise } from "q";


export default {
  data() {
    return {
      transcript: "",
      mensaje: "",
      exito: false,
      liquidacionid: "",
      turnoid: "",
      servicioid: "",
      url: process.env.VUE_APP_CLOUDINARY_URL_ROOT + "api/movimientos/",
    }
  },

  created() {
    this.listar();

  },


  methods: {
    iniciarReconocimiento() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

      if (!SpeechRecognition) {
        alert('Tu navegador no soporta reconocimiento de voz');
        return;
      }

      const recognition = new SpeechRecognition();
      recognition.lang = 'es-ES';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.onresult = (event) => {
        const texto = event.results[0][0].transcript.toLowerCase();
        this.transcript = texto;
        this.procesarComando(texto);
      };

      recognition.onerror = (event) => {
        console.error('Error de reconocimiento:', event.error);
        this.mensaje = 'Error al reconocer voz: ' + event.error;
        this.exito = false;
      };

      recognition.start();
    },

    procesarComando(texto) {

      const regex = /(bancaria|efectivo|cheque|cupones|créditos|accord|efecticar|dólares|transferencia|sodexo|ultra gas|aceites|crédito aceites|bienestar|tienda|imprime)\s+(.+)/i;
      const match = texto.match(regex);

      if (!match) {
        this.mensaje = 'No se reconoció un comando válido';
        this.exito = false;
        return;
      }

      const tipo = match[1].toLowerCase();
      const valorTexto = match[2].trim();

      const textoSinEspacios = valorTexto.replace(/[\s,]/g, "");
    
      // Intentar extraer número directamente
      const numero = textoSinEspacios.match(/[0-9]+(?:\.[0-9]{1,2})?/);
      let valor = 0;

      if (numero) {
        valor = parseFloat(numero[0]);
      } else {
        valor = this.convertirTextoANumero(valorTexto);

      }

      if (isNaN(valor) || valor <= 0) {
        this.mensaje = 'No se pudo interpretar el valor numérico.';
        this.exito = false;
        return;
      }

      this.enviarTransaccion(tipo, valor);
    },

    convertirTextoANumero(texto) {
      const map = {
        'cero': 0, 'uno': 1, 'una': 1, 'dos': 2, 'tres': 3, 'cuatro': 4, 'cinco': 5,
        'seis': 6, 'siete': 7, 'ocho': 8, 'nueve': 9, 'diez': 10, 'once': 11,
        'doce': 12, 'trece': 13, 'catorce': 14, 'quince': 15, 'veinte': 20,
        'treinta': 30, 'cuarenta': 40, 'cincuenta': 50, 'sesenta': 60,
        'setenta': 70, 'ochenta': 80, 'noventa': 90, 'cien': 100, 'ciento': 100,
        'doscientos': 200, 'trescientos': 300, 'cuatrocientos': 400,
        'quinientos': 500, 'seiscientos': 600, 'setecientos': 700,
        'ochocientos': 800, 'novecientos': 900, 'mil': 1000, 'millón': 1000000,
        'millones': 1000000
      };

      const palabras = texto.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(' ');
      let total = 0;
      let parcial = 0;

      for (let palabra of palabras) {
        const valor = map[palabra];
        if (valor == null) continue;

        if (valor === 1000 || valor === 1000000) {
          if (parcial === 0) parcial = 1;
          total += parcial * valor;
          parcial = 0;
        } else {
          parcial += valor;
        }
      }

      return total + parcial;
    },

    async enviarTransaccion(tipo, valor) {

      if(tipo=="imprime"){
        this.pdfliquidacion();
      }else{
        this.guardar(tipo, valor);
      }
      
    },

     pdfliquidacion() {
      window.open(
        this.url +
        "pdfmovimientodespachador/" +
        this.$store.state.usuario.usuarioid +
        "/" +
        this.$store.state.usuario.fecha 
      );
    },


    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: me.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/usuarios/usuarioliquidafecha/" + me.$store.state.usuario.usuarioid + "/" + me.$store.state.usuario.fecha, configuracion)
        .then(function (response) {
          console.log(response.data.liquidacion);

          me.liquidacionid = response.data.liquidacion.liquidacionid;
          me.turnoid = response.data.liquidacion.liquidacionturno;

        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },




    guardar(tipo, valor) {

      if (tipo == "efectivo") {
        this.servicioid = 1;
      }
      if (tipo == "bancaria") {
        this.servicioid = 2;
      }

      if (tipo == "créditos") {
        this.servicioid = 3;
      }

      if (tipo == "accord") {
        this.servicioid = 4;
      }

      if (tipo == "efecticar") {
        this.servicioid = 5;
      }

      if (tipo == "dólares") {
        this.servicioid = 6;
      }

      if (tipo == "cupones") {
        this.servicioid = 7;
      }

      if (tipo == "cheque") {
        this.servicioid = 8;
      }

      if (tipo == "transferencia") {
        this.servicioid = 9;
      }

      if (tipo == "sodexo") {
        this.servicioid = 10;
      }

      if (tipo == "ultra gas") {
        this.servicioid = 11;
      }

      if (tipo == "aceites") {
        this.servicioid = 12;
      }

      if (tipo == "crédito aceites") {
        this.servicioid = 13;
      }

      if (tipo == "bienestar") {
        this.servicioid = 14;
      }

      if (tipo == "tienda") {
        this.servicioid = 15;
      }


      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      var totalmovimiento = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(valor);


      me.$swal({
        icon: "warning",
        title: "Estas Seguro de GUARDAR",
        text:
          "Operacion: " + tipo + " por la Cantidad de: " + totalmovimiento,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post(
              "api/movimientos/crear",
              {
                liquidacionid: me.liquidacionid,
                servicioid: me.servicioid,
                movimientoimporte: valor,
                //movimientoobservacion: "",
                movimientofecha: me.$store.state.usuario.fecha,
                turnoid: me.turnoid,
                //clienteigas: me.clienteigas,
                //credito: me.credito,
                //restobilleteefectivo: me.restobilleteefectivo,
                //creditoticket: me.creditoticket,
                combustibleid: 1,
                //creditolitros: me.creditolitros,
                //creditounidad: me.creditounidad,
                //creditoautorizaocarga: me.creditoautorizaocarga,
                //creditovale: me.creditovale,
                //movimientovalor: me.movimientodolares,
                //movimientoparametrovalor: me.movimientovalordolares,
                //sucursalid: me.sucursalid,
                //departamentoid: me.departamentoid,
              },
              configuracion
            )
            .then(function (response) {
              me.$swal("Guardado", "Se a Guardado: " + tipo + " por la Cantidad de: " + totalmovimiento, "success");
              me.transcript = "";
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.$swal("No se Inserto El Registro Checar");
              }
            });
        }
      });









    },






  }
}
</script>

<style scoped>
button {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
}

p {
  margin-top: 10px;
}

.success {
  color: green;
}

.error {
  color: red;
}
</style>